export default __webpack_public_path__ + "static/media/3.e3109b9d.png";